import LogoIconSvg from "@/assets/icons/logo.svg"
import LogoFullSvg from "@/assets/icons/logoFull.svg"
import { SIDEBAR_TEXTS } from "@/constants/sidebar-texts"
import { ADMIN_ROUTES } from "@/config/admin-routes"
import { INTERNAL_ROLES } from "@/features/auth/api/types"
import {
  CrashGamesIcon,
  ChallengesIcon,
  LiveCasinoIcon,
  ManageAdminsIcon,
  ManageStreamersIcon,
  NewsIcon,
  ReportsIcon,
  SlotsIcon,
  StreamStatsIcon,
  RoadmapIcon,
} from "@/layouts/app-shell/navigation/navigation-icons"
import { type SidebarConfig } from "@/types/sidebar"

// Default/Streamer Hub sidebar configuration
export const streamerHubSidebarConfig: SidebarConfig = {
  streamerHubInfo: {
    logo: LogoFullSvg,
    icon: LogoIconSvg,
  },
  navGroups: [
    {
      // No title — main streamer items (Figma: first unlabelled section)
      items: [
        {
          title: SIDEBAR_TEXTS.nav.streamStats,
          url: "/",
          icon: StreamStatsIcon,
          roles: ["STREAMER"],
        },
        {
          title: "Challenges",
          url: "/challenges",
          icon: ChallengesIcon,
        },
        {
          title: SIDEBAR_TEXTS.nav.news,
          url: "/news",
          icon: NewsIcon,
        },
      ],
    },
    {
      // Figma: "STREAM ASSETS" section, preceded by gradient divider
      title: SIDEBAR_TEXTS.sections.games,
      dividerBefore: true,
      items: [
        {
          title: SIDEBAR_TEXTS.nav.slots,
          url: "/slots/library",
          icon: SlotsIcon,
        },
        {
          title: SIDEBAR_TEXTS.nav.liveCasino,
          url: "/live-casino/library",
          icon: LiveCasinoIcon,
        },
        {
          title: SIDEBAR_TEXTS.nav.crashGames,
          url: "/crash-games",
          icon: CrashGamesIcon,
        },
        {
          title: SIDEBAR_TEXTS.nav.roadmaps,
          url: "/roadmaps",
          icon: RoadmapIcon,
        },
      ],
    },
  ],
  navBackOffice: [
    {
      name: "Manage Challenges",
      url: ADMIN_ROUTES.challenges,
      icon: ChallengesIcon,
      roles: ["ADMIN", "SUPER_ADMIN", "PLATFORM_ENGINEER"],
    },
    {
      name: "Manage Streamers",
      url: ADMIN_ROUTES.streamers,
      icon: ManageStreamersIcon,
      roles: INTERNAL_ROLES,
    },
    {
      name: SIDEBAR_TEXTS.backOffice.manageAdmins,
      url: ADMIN_ROUTES.users,
      icon: ManageAdminsIcon,
      roles: ["SUPER_ADMIN", "PLATFORM_ENGINEER"],
    },
    {
      name: SIDEBAR_TEXTS.backOffice.reports,
      url: ADMIN_ROUTES.reports,
      icon: ReportsIcon,
      roles: ["ADMIN", "SUPER_ADMIN", "PLATFORM_ENGINEER"],
    },
  ],
}

// Helper function to get sidebar config based on route
export function getSidebarConfig(pathname: string): SidebarConfig {
  void pathname
  // Default to streamer hub config
  return streamerHubSidebarConfig
}
